import React from "react";
import ContentPageTemplate from "../components/ContentPageTemplate";
import { industryPages } from "../data/industryPages";

export default function WebdesignFuerRestaurants() {
  return <ContentPageTemplate {...industryPages.restaurants} />;
}
